import { Fukidashi } from "../../../../content/entry/2020-11-30/uhyo-teckstack-2020/Fukidashi.tsx";
import * as React from 'react';
export default {
  Fukidashi,
  React
};